module.exports = __webpack_public_path__ + "assets/img/chuchuang.d64806aa.jpg";